import React, { Component } from 'react';
import _ from 'lodash';

class ToDoCount extends Component {


  renderTasksCount() {
    const tasksCount =  _.size(this.props.todos);
    return tasksCount === 1 ? '1 task:' : (tasksCount + ' Tasks :');
  }

  render(){
    return <div className="cardSubtitle" style={{  }}>{ this.renderTasksCount() }</div>
}
}

export default  ToDoCount;
